import { render, staticRenderFns } from "./ModifiedLevel.vue?vue&type=template&id=b9d123ca&scoped=true&"
import script from "./ModifiedLevel.vue?vue&type=script&lang=js&"
export * from "./ModifiedLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d123ca",
  null
  
)

export default component.exports